
import dataName from './data-name.js'
import {genDefaultModuleOfList, genDefaultModuleOfEditor} from '@/data/base/store.js'
import DataService from './service.js'
var service = new DataService()

// custom...
// listState = Object.assign(listState, {
// })
const store = {
  namespaced: true,
  modules: {
    list: genDefaultModuleOfList(dataName, service),
    editor: genDefaultModuleOfEditor(dataName, service)
  }
}
export default store
